import Controller from "@ember/controller";
import { action, computed } from "@ember/object";
import { popupAjaxError } from "discourse/lib/ajax-error";
import { uniqueItemsFromArray } from "discourse/lib/array-tools";
import { makeArray } from "discourse/lib/helpers";
import { applyValueTransformer } from "discourse/lib/transformer";
import { i18n } from "discourse-i18n";

export default class UsersController extends Controller {
  subpageTitle = i18n("user.preferences_nav.users");

  @computed(
    "model.user_option.enable_allowed_pm_users",
    "model.user_option.allow_private_messages"
  )
  get allowPmUsersEnabled() {
    return (
      this.model?.user_option?.enable_allowed_pm_users &&
      this.model?.user_option?.allow_private_messages
    );
  }

  get saveAttrNames() {
    return applyValueTransformer(
      "preferences-save-attributes",
      [
        "allow_private_messages",
        "muted_usernames",
        "allowed_pm_usernames",
        "enable_allowed_pm_users",
      ],
      { page: "users" }
    );
  }

  @computed("model.muted_usernames")
  get mutedUsernames() {
    let usernames = this.model.muted_usernames;

    if (typeof usernames === "string") {
      usernames = usernames.split(",").filter(Boolean);
    }

    return uniqueItemsFromArray(makeArray(usernames));
  }

  @computed("model.allowed_pm_usernames")
  get allowedPmUsernames() {
    let usernames = this.model.allowed_pm_usernames;

    if (typeof usernames === "string") {
      usernames = usernames.split(",").filter(Boolean);
    }

    return uniqueItemsFromArray(makeArray(usernames));
  }

  @action
  onChangeMutedUsernames(usernames) {
    this.model.set(
      "muted_usernames",
      uniqueItemsFromArray(usernames).join(",")
    );
  }

  @action
  onChangeAllowedPmUsernames(usernames) {
    this.model.set(
      "allowed_pm_usernames",
      uniqueItemsFromArray(usernames).join(",")
    );
  }

  @computed("model.user_option.allow_private_messages")
  get disableAllowPmUsersSetting() {
    return !this.model?.user_option?.allow_private_messages;
  }

  @action
  save() {
    this.set("saved", false);

    return this.model
      .save(this.saveAttrNames)
      .then(() => this.set("saved", true))
      .catch(popupAjaxError);
  }
}
